import Rails from '@rails/ujs';
import 'bootstrap';
import '@popperjs/core';

import '../../scripts/controllers';
import '../../scripts/turbo_config';
import '../../scripts/page_alert_driver';
import '../../scripts/utilities';

Rails.start();
